import React from 'react';
import { AuthorizationFormViewRendererProps } from '../types';
import Desktop from './Desktop';

function ViewRenderer(props: AuthorizationFormViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
